var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LocalizationProvider as MuiLocalizationProvider, } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import us from "date-fns/locale/en-US";
const LocalizationProvider = (_a) => {
    var { children, dateAdapter = AdapterDateFns } = _a, properties = __rest(_a, ["children", "dateAdapter"]);
    return (_jsx(MuiLocalizationProvider, Object.assign({ dateAdapter: dateAdapter, adapterLocale: us }, properties, { children: children })));
};
export default LocalizationProvider;
